// Comprehensive country codes for dropdown with flag images
export const countryCodes = [
  { code: '+1', country: 'us', name: 'United States' },
  { code: '+1-242', country: 'bs', name: 'Bahamas' },
  { code: '+1-246', country: 'bb', name: 'Barbados' },
  { code: '+1-264', country: 'ai', name: 'Anguilla' },
  { code: '+1-268', country: 'ag', name: 'Antigua and Barbuda' },
  { code: '+1-284', country: 'vg', name: 'British Virgin Islands' },
  { code: '+1-340', country: 'vi', name: 'US Virgin Islands' },
  { code: '+1-345', country: 'ky', name: 'Cayman Islands' },
  { code: '+1-441', country: 'bm', name: 'Bermuda' },
  { code: '+1-473', country: 'gd', name: 'Grenada' },
  { code: '+1-649', country: 'tc', name: 'Turks and Caicos' },
  { code: '+1-664', country: 'ms', name: 'Montserrat' },
  { code: '+1-670', country: 'mp', name: 'Northern Mariana Islands' },
  { code: '+1-671', country: 'gu', name: 'Guam' },
  { code: '+1-684', country: 'as', name: 'American Samoa' },
  { code: '+1-767', country: 'dm', name: 'Dominica' },
  { code: '+1-758', country: 'lc', name: 'Saint Lucia' },
  { code: '+1-784', country: 'vc', name: 'Saint Vincent' },
  { code: '+1-787', country: 'pr', name: 'Puerto Rico' },
  { code: '+1-809', country: 'do', name: 'Dominican Republic' },
  { code: '+1-868', country: 'tt', name: 'Trinidad and Tobago' },
  { code: '+1-869', country: 'kn', name: 'Saint Kitts and Nevis' },
  { code: '+1-876', country: 'jm', name: 'Jamaica' },
  { code: '+7', country: 'ru', name: 'Russia / Kazakhstan' },
  { code: '+20', country: 'eg', name: 'Egypt' },
  { code: '+27', country: 'za', name: 'South Africa' },
  { code: '+30', country: 'gr', name: 'Greece' },
  { code: '+31', country: 'nl', name: 'Netherlands' },
  { code: '+32', country: 'be', name: 'Belgium' },
  { code: '+33', country: 'fr', name: 'France' },
  { code: '+34', country: 'es', name: 'Spain' },
  { code: '+36', country: 'hu', name: 'Hungary' },
  { code: '+39', country: 'it', name: 'Italy' },
  { code: '+40', country: 'ro', name: 'Romania' },
  { code: '+41', country: 'ch', name: 'Switzerland' },
  { code: '+43', country: 'at', name: 'Austria' },
  { code: '+44', country: 'gb', name: 'United Kingdom' },
  { code: '+44-1481', country: 'gg', name: 'Guernsey' },
  { code: '+44-1534', country: 'je', name: 'Jersey' },
  { code: '+44-1624', country: 'im', name: 'Isle of Man' },
  { code: '+45', country: 'dk', name: 'Denmark' },
  { code: '+46', country: 'se', name: 'Sweden' },
  { code: '+47', country: 'no', name: 'Norway' },
  { code: '+48', country: 'pl', name: 'Poland' },
  { code: '+49', country: 'de', name: 'Germany' },
  { code: '+51', country: 'pe', name: 'Peru' },
  { code: '+52', country: 'mx', name: 'Mexico' },
  { code: '+53', country: 'cu', name: 'Cuba' },
  { code: '+54', country: 'ar', name: 'Argentina' },
  { code: '+55', country: 'br', name: 'Brazil' },
  { code: '+56', country: 'cl', name: 'Chile' },
  { code: '+57', country: 'co', name: 'Colombia' },
  { code: '+58', country: 've', name: 'Venezuela' },
  { code: '+60', country: 'my', name: 'Malaysia' },
  { code: '+61', country: 'au', name: 'Australia' },
  { code: '+62', country: 'id', name: 'Indonesia' },
  { code: '+63', country: 'ph', name: 'Philippines' },
  { code: '+64', country: 'nz', name: 'New Zealand' },
  { code: '+65', country: 'sg', name: 'Singapore' },
  { code: '+66', country: 'th', name: 'Thailand' },
  { code: '+81', country: 'jp', name: 'Japan' },
  { code: '+82', country: 'kr', name: 'South Korea' },
  { code: '+84', country: 'vn', name: 'Vietnam' },
  { code: '+86', country: 'cn', name: 'China' },
  { code: '+90', country: 'tr', name: 'Turkey' },
  { code: '+91', country: 'in', name: 'India' },
  { code: '+92', country: 'pk', name: 'Pakistan' },
  { code: '+93', country: 'af', name: 'Afghanistan' },
  { code: '+94', country: 'lk', name: 'Sri Lanka' },
  { code: '+95', country: 'mm', name: 'Myanmar' },
  { code: '+98', country: 'ir', name: 'Iran' },
  { code: '+211', country: 'ss', name: 'South Sudan' },
  { code: '+212', country: 'ma', name: 'Morocco' },
  { code: '+216', country: 'tn', name: 'Tunisia' },
  { code: '+218', country: 'ly', name: 'Libya' },
  { code: '+220', country: 'gm', name: 'Gambia' },
  { code: '+221', country: 'sn', name: 'Senegal' },
  { code: '+222', country: 'mr', name: 'Mauritania' },
  { code: '+223', country: 'ml', name: 'Mali' },
  { code: '+224', country: 'gn', name: 'Guinea' },
  { code: '+225', country: 'ci', name: 'Ivory Coast' },
  { code: '+226', country: 'bf', name: 'Burkina Faso' },
  { code: '+227', country: 'ne', name: 'Niger' },
  { code: '+228', country: 'tg', name: 'Togo' },
  { code: '+229', country: 'bj', name: 'Benin' },
  { code: '+230', country: 'mu', name: 'Mauritius' },
  { code: '+231', country: 'lr', name: 'Liberia' },
  { code: '+232', country: 'sl', name: 'Sierra Leone' },
  { code: '+233', country: 'gh', name: 'Ghana' },
  { code: '+234', country: 'ng', name: 'Nigeria' },
  { code: '+235', country: 'td', name: 'Chad' },
  { code: '+236', country: 'cf', name: 'Central African Republic' },
  { code: '+237', country: 'cm', name: 'Cameroon' },
  { code: '+238', country: 'cv', name: 'Cape Verde' },
  { code: '+239', country: 'st', name: 'São Tomé and Príncipe' },
  { code: '+240', country: 'gq', name: 'Equatorial Guinea' },
  { code: '+241', country: 'ga', name: 'Gabon' },
  { code: '+242', country: 'cg', name: 'Republic of the Congo' },
  { code: '+243', country: 'cd', name: 'DR Congo' },
  { code: '+244', country: 'ao', name: 'Angola' },
  { code: '+245', country: 'gw', name: 'Guinea-Bissau' },
  { code: '+246', country: 'io', name: 'British Indian Ocean Territory' },
  { code: '+248', country: 'sc', name: 'Seychelles' },
  { code: '+249', country: 'sd', name: 'Sudan' },
  { code: '+250', country: 'rw', name: 'Rwanda' },
  { code: '+251', country: 'et', name: 'Ethiopia' },
  { code: '+252', country: 'so', name: 'Somalia' },
  { code: '+253', country: 'dj', name: 'Djibouti' },
  { code: '+254', country: 'ke', name: 'Kenya' },
  { code: '+255', country: 'tz', name: 'Tanzania' },
  { code: '+256', country: 'ug', name: 'Uganda' },
  { code: '+257', country: 'bi', name: 'Burundi' },
  { code: '+258', country: 'mz', name: 'Mozambique' },
  { code: '+260', country: 'zm', name: 'Zambia' },
  { code: '+261', country: 'mg', name: 'Madagascar' },
  { code: '+262', country: 're', name: 'Réunion' },
  { code: '+263', country: 'zw', name: 'Zimbabwe' },
  { code: '+264', country: 'na', name: 'Namibia' },
  { code: '+265', country: 'mw', name: 'Malawi' },
  { code: '+266', country: 'ls', name: 'Lesotho' },
  { code: '+267', country: 'bw', name: 'Botswana' },
  { code: '+268', country: 'sz', name: 'Eswatini' },
  { code: '+269', country: 'km', name: 'Comoros' },
  { code: '+290', country: 'sh', name: 'Saint Helena' },
  { code: '+291', country: 'er', name: 'Eritrea' },
  { code: '+297', country: 'aw', name: 'Aruba' },
  { code: '+298', country: 'fo', name: 'Faroe Islands' },
  { code: '+299', country: 'gl', name: 'Greenland' },
  { code: '+350', country: 'gi', name: 'Gibraltar' },
  { code: '+351', country: 'pt', name: 'Portugal' },
  { code: '+352', country: 'lu', name: 'Luxembourg' },
  { code: '+354', country: 'is', name: 'Iceland' },
  { code: '+356', country: 'mt', name: 'Malta' },
  { code: '+357', country: 'cy', name: 'Cyprus' },
  { code: '+358', country: 'fi', name: 'Finland' },
  { code: '+359', country: 'bg', name: 'Bulgaria' },
  { code: '+370', country: 'lt', name: 'Lithuania' },
  { code: '+371', country: 'lv', name: 'Latvia' },
  { code: '+372', country: 'ee', name: 'Estonia' },
  { code: '+373', country: 'md', name: 'Moldova' },
  { code: '+374', country: 'am', name: 'Armenia' },
  { code: '+375', country: 'by', name: 'Belarus' },
  { code: '+376', country: 'ad', name: 'Andorra' },
  { code: '+377', country: 'mc', name: 'Monaco' },
  { code: '+378', country: 'sm', name: 'San Marino' },
  { code: '+379', country: 'va', name: 'Vatican City' },
  { code: '+380', country: 'ua', name: 'Ukraine' },
  { code: '+381', country: 'rs', name: 'Serbia' },
  { code: '+382', country: 'me', name: 'Montenegro' },
  { code: '+383', country: 'xk', name: 'Kosovo' },
  { code: '+385', country: 'hr', name: 'Croatia' },
  { code: '+386', country: 'si', name: 'Slovenia' },
  { code: '+387', country: 'ba', name: 'Bosnia and Herzegovina' },
  { code: '+389', country: 'mk', name: 'North Macedonia' },
  { code: '+420', country: 'cz', name: 'Czech Republic' },
  { code: '+421', country: 'sk', name: 'Slovakia' },
  { code: '+423', country: 'li', name: 'Liechtenstein' },
  { code: '+500', country: 'fk', name: 'Falkland Islands' },
  { code: '+501', country: 'bz', name: 'Belize' },
  { code: '+502', country: 'gt', name: 'Guatemala' },
  { code: '+503', country: 'sv', name: 'El Salvador' },
  { code: '+504', country: 'hn', name: 'Honduras' },
  { code: '+505', country: 'ni', name: 'Nicaragua' },
  { code: '+506', country: 'cr', name: 'Costa Rica' },
  { code: '+507', country: 'pa', name: 'Panama' },
  { code: '+508', country: 'pm', name: 'Saint Pierre and Miquelon' },
  { code: '+509', country: 'ht', name: 'Haiti' },
  { code: '+590', country: 'bl', name: 'Saint Barthélemy' },
  { code: '+591', country: 'bo', name: 'Bolivia' },
  { code: '+592', country: 'gy', name: 'Guyana' },
  { code: '+593', country: 'ec', name: 'Ecuador' },
  { code: '+595', country: 'py', name: 'Paraguay' },
  { code: '+597', country: 'sr', name: 'Suriname' },
  { code: '+598', country: 'uy', name: 'Uruguay' },
  { code: '+599', country: 'cw', name: 'Curaçao' },
  { code: '+670', country: 'tl', name: 'East Timor' },
  { code: '+672', country: 'aq', name: 'Antarctica' },
  { code: '+673', country: 'bn', name: 'Brunei' },
  { code: '+674', country: 'nr', name: 'Nauru' },
  { code: '+675', country: 'pg', name: 'Papua New Guinea' },
  { code: '+676', country: 'to', name: 'Tonga' },
  { code: '+677', country: 'sb', name: 'Solomon Islands' },
  { code: '+678', country: 'vu', name: 'Vanuatu' },
  { code: '+679', country: 'fj', name: 'Fiji' },
  { code: '+680', country: 'pw', name: 'Palau' },
  { code: '+681', country: 'wf', name: 'Wallis and Futuna' },
  { code: '+682', country: 'ck', name: 'Cook Islands' },
  { code: '+683', country: 'nu', name: 'Niue' },
  { code: '+685', country: 'ws', name: 'Samoa' },
  { code: '+686', country: 'ki', name: 'Kiribati' },
  { code: '+687', country: 'nc', name: 'New Caledonia' },
  { code: '+688', country: 'tv', name: 'Tuvalu' },
  { code: '+689', country: 'pf', name: 'French Polynesia' },
  { code: '+690', country: 'tk', name: 'Tokelau' },
  { code: '+691', country: 'fm', name: 'Micronesia' },
  { code: '+692', country: 'mh', name: 'Marshall Islands' },
  { code: '+850', country: 'kp', name: 'North Korea' },
  { code: '+852', country: 'hk', name: 'Hong Kong' },
  { code: '+853', country: 'mo', name: 'Macau' },
  { code: '+855', country: 'kh', name: 'Cambodia' },
  { code: '+856', country: 'la', name: 'Laos' },
  { code: '+880', country: 'bd', name: 'Bangladesh' },
  { code: '+886', country: 'tw', name: 'Taiwan' },
  { code: '+960', country: 'mv', name: 'Maldives' },
  { code: '+961', country: 'lb', name: 'Lebanon' },
  { code: '+962', country: 'jo', name: 'Jordan' },
  { code: '+963', country: 'sy', name: 'Syria' },
  { code: '+964', country: 'iq', name: 'Iraq' },
  { code: '+965', country: 'kw', name: 'Kuwait' },
  { code: '+966', country: 'sa', name: 'Saudi Arabia' },
  { code: '+967', country: 'ye', name: 'Yemen' },
  { code: '+968', country: 'om', name: 'Oman' },
  { code: '+970', country: 'ps', name: 'Palestine' },
  { code: '+971', country: 'ae', name: 'UAE' },
  { code: '+972', country: 'il', name: 'Israel' },
  { code: '+973', country: 'bh', name: 'Bahrain' },
  { code: '+974', country: 'qa', name: 'Qatar' },
  { code: '+975', country: 'bt', name: 'Bhutan' },
  { code: '+976', country: 'mn', name: 'Mongolia' },
  { code: '+977', country: 'np', name: 'Nepal' },
  { code: '+992', country: 'tj', name: 'Tajikistan' },
  { code: '+993', country: 'tm', name: 'Turkmenistan' },
  { code: '+994', country: 'az', name: 'Azerbaijan' },
  { code: '+995', country: 'ge', name: 'Georgia' },
  { code: '+996', country: 'kg', name: 'Kyrgyzstan' },
  { code: '+998', country: 'uz', name: 'Uzbekistan' }
];

